import { Component, OnInit } from '@angular/core';
 
import { SpinnerService } from './spinner.service';
 
@Component({
    moduleId: module.id,
    selector: 'spinner',
    templateUrl: 'spinner.component.html'
})
 
export class SpinnerComponent {
    showSpinner: boolean;
    message: string;

    constructor(private spinnerService: SpinnerService) { 
        this.showSpinner = false;
        this.message = "";
    }

    ngOnInit(): void {
      this.showSpinner = this.spinnerService.isVisible();
      this.spinnerService.spinnerChanged$.subscribe(show => this.onSpinnerChanged(show));
    }

    private onSpinnerChanged(show: boolean): void {
      this.showSpinner = show;
      this.message = this.spinnerService.getMessage();
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/spinner/spinner.component.ts